export default __webpack_public_path__ + "images/3a0d1be28a35dc9e8738a15c93f84a4b.svg";